import React from 'react'
import PropTypes from 'prop-types'
// @todo replace with SEO header
import Helmet from 'react-helmet'
import styled from 'react-emotion'

import {
	MAX_WIDTH,
	SPACERS,
} from 'utils/styleHelpers'

import Header from 'components/Header'
import OmniSearch from 'components/OmniSearch'

const Body = styled.main`
	margin: 0 auto;
	max-width: ${MAX_WIDTH};
	padding-bottom: ${SPACERS.L};
	padding-right: ${SPACERS.L};
	padding-left: ${SPACERS.L};
`

const TemplateWrapper = ({ children }) => (
	<div>
		<Helmet
			meta={[
				{ name: 'description', content: 'Sample' },
				{ name: 'keywords', content: 'sample, something' },
				{ name: 'google-site-verification', content: 'Rtd0Vva48ZrlzgSGNLSUiXFvdyX2oQHCc66ZIbkU4Q4' }
			]}
			title='WeedRater'
		/>
		
		<link
			href='https://cdn.jsdelivr.net/npm/instantsearch.css@7.0.0/themes/algolia-min.css'
			rel='stylesheet'
			type='text/css'
		/>
		<Header />
		{/* <OmniSearch /> */}
		<Body>
			{children()}
		</Body>
	</div>
)

TemplateWrapper.propTypes = {
	children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js